<!--
 * @Author: 吴俊杰 13202481990@qq.com
 * @Date: 2023-02-06 15:09:54
 * @LastEditors: 吴俊杰 13202481990@qq.com
 * @LastEditTime: 2023-12-15 11:45:41
 * @FilePath: /ushknews/src/views/calendar/modules/MobileContent/EconomicsList.vue
 * @Description:
 *
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved.
-->
<template>
  <ul class="ushk-rili_list-wrap J_rili_listItem">
    <li class="ushk-rili_list-empty" v-if="!datas || !datas.length">
        <img src="//cdn.jin10.com/assets/img/sites/rili/empty_rili.png">
        <p>{{ !datas ? '加载中......' : noneText }}</p>
    </li>
    <li v-for="(data, index) in datas" class="ushk-rili_list-item" :class="{important: data.star > 2}">
      <div class="ushk-rili_list-country">
          <img :src="`//cdn.jin10.com/assets/img/commons/flag/flash/${data.country}.png`">
      </div>
      <div class="ushk-rili_list-body">
          <div class="ushk-rili_list-h">
              <div class="ushk-rili_list-time">
                  <i class="ushk-icon ushk-icon_time"></i>
                  <span>{{ data.time_show }}</span>
              </div>
              <star :width="data.star"/>
          </div>
          <h3 class="ushk-rili_list-title">{{ data.title }}</h3>
          <div class="ushk-rili_list-info">
              <p>前值：
                <template v-if="data.revised !== null && data.revised !== ''">
                  {{ data.revised }}
                </template>
                <template v-else>
                  {{ data.previous }}{{ data.unit === '%' ? data.unit : '' }}
                </template>
              </p>
              <p>预期：

                  <template v-if="data.consensus !== null && data.consensus !== ''">
                    {{ data.consensus }}{{ data.unit === '%' ? data.unit : '' }}
                  </template>
                  <template v-else>
                    ---
                  </template>
              </p>
              <p>公布：
                  <span id="<%= item.dataId %>">
                    <template v-if="data.actual !== null &&data.actual !== ''">
                      {{ data.actual }}{{ data.unit === '%' ? data.unit : '' }}
                    </template>
                    <template v-else>
                      ---
                    </template>
                  </span>
              </p>
          </div>
      </div>
      <div id="J_<%= item.dataId %>" class="ushk-rili_list-tag" v-if="data.show_affect && data.country !== '中国'">
          <div class="ushk-tag_trend">
              <p :class="data.status_class ? data.status_class : 'default'">
                  <span class="ushk-btn J_kind_tag" data-trend="1">
                    <em v-if="data.status_name === '未公布'" class="J_kind_trend">---</em>
                    <template v-else>
                      <em class="J_kind_trend">{{ data.status_name }}</em> <i class="J_kind_trendType">股票</i>
                    </template>
                  </span>
              </p>
          </div>
      </div>
    </li>
  </ul>
</template>

<script>
  export default {
    props: {
      datas: {
        type: [Array, Boolean],
        default: false
      },
      noneText: {
        type: String,
        default: '今日无重要经济数据'
      }
    },
    data () {
      return {
      }
    }
  }
</script>



// WEBPACK FOOTER //
// EconomicsList.vue?2a45593e